<template lang="pug">
  span.rating(v-if="typeof value === 'number'")
    .rating__wrap
      .rating__stars(:style="`width: ${value}%`")
    a.rating__link(v-if="linkUrl && linkText" :href="linkUrl" target="_blank") {{ linkText }}
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    linkUrl: {
      type: String,
      required: false,
    },
    linkText: {
      type: String,
      required: false,
    }
  }
}
</script>
